import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, TemplateRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { BehaviorSubject, of } from 'rxjs';

import {
  RouteTabGroupComponent,
  TabGroupConfig,
} from '@features/tab-group/route-tab-group.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, RouteTabGroupComponent, RouterOutlet, AsyncPipe],
  selector: 'aux-design-system',
  templateUrl: './design-system.component.html',
})
export class DesignSystemComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  activeTabIndex$ = new BehaviorSubject<number>(0);
  rightSideContainer = new BehaviorSubject<null | TemplateRef<unknown>>(null);
  tabs: TabGroupConfig[] = [
    {
      label: 'Colors',
      route: '/design-system/colors',
      show: of(true),
    },
    {
      label: 'Iconography',
      route: '/design-system/iconography',
      show: of(true),
    },
    {
      label: 'Buttons',
      route: '/design-system/buttons',
      show: of(true),
    },
    {
      label: 'Button Toggle Group',
      route: '/design-system/button-toggle-group-demo',
      show: of(true),
    },
    {
      label: 'Data Components',
      route: '/design-system/data-components',
      show: of(true),
    },
    {
      label: 'Forms & Controls',
      route: '/design-system/forms-and-controls',
      show: of(true),
    },
    {
      label: 'Tables',
      route: '/design-system/tables',
      show: of(true),
    },
    {
      label: 'Modals & Cards',
      route: '/design-system/modals',
      show: of(true),
    },
    {
      label: 'Typography',
      route: '/design-system/typography',
      show: of(true),
    },
    {
      label: 'Badge Status',
      route: '/design-system/badge-status',
      show: of(true),
    },
  ];

  constructor() {
    this.route.queryParams.pipe(takeUntilDestroyed()).subscribe((params) => {
      if (params.activeTabIndex) {
        this.activeTabIndex$.next(parseInt(params.activeTabIndex, 10));
        void this.router.navigate([], { queryParams: {}, replaceUrl: true });
      }
    });
  }
}
